
import React, { useEffect } from 'react'
import AddHeader from '../components/AddHeader/AddHeader'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FilterContainer from '../components/FilterContainer/FilterContainer';
import CustomTable from '../components/CustomTable/CustomTable';
import VisibilityIcon from '@mui/icons-material/Visibility'
import { fetchUsers } from '../hooks/Users';
// import { fetchUsers } from '../hooks/users';

function Users() {
    const navigate = useNavigate();
    const dispatch=useDispatch()
  const { currentLocal } = useSelector((state) => state.currentLocal);
        const {list:users } = useSelector((state) => state.users);
        console.log(users);
        
    useEffect(() => {
          dispatch(fetchUsers());
    
    }, [dispatch])
  
  const header = [
    { id: "id", numeric: false, disablePadding: true, label: currentLocal.home.ID },
    { id: "name", numeric: true, disablePadding: false, label:  currentLocal.home.namePlaceholder },
    { id: "email", numeric: true, disablePadding: false, label: currentLocal.home.email},
      { id: "phone", numeric: true, disablePadding: false, label: currentLocal.home.phone},
  
  
    { id: "actions", numeric: true, disablePadding: false, label: currentLocal.home.actions },

  ];
  
const myData = users?.map((item) => {
  console.log(item);
  
  return {
    id: item?.id,
        image:<>
        <div className='w-25'>
          <img src={ item.image}alt=''className='w-50'/>
        </div>
        </> || '---', 

    name: item.name || '---',
    email: item.email || '---',
    phone: item.phone || '---',
    actions: (
      <div className='d-flex align-items-center'>
        <div 
          className='d-flex align-items-center' 
          style={{ cursor: "pointer" }} 
          onClick={() => navigate(`/dashboard/user/${item?.id}`)}
        >
    <VisibilityIcon
            sx={{
              color: '#6C757D',
              fontSize: '1rem',
              marginLeft: '5px'
            }}
          />
          <p className='mb-0' style={{ fontSize: '1rem', color: '#6C757D' }}>
            {currentLocal.home.Preview}
          </p>
        </div>
      </div>
    )
  };
});
  return (
    <div className='outlit_bg px-4'>
      <AddHeader
        title={currentLocal.home.users}
        text={currentLocal.home.adduser}
        handleSubmit={() => navigate("/dashboard/add-user")}
      />
      <FilterContainer
        exportexcel={false}
        searchState={false}
      />
{users?.length>0&&
      <div className='mx-4'>
        <CustomTable
          headCells={header}
          rows={myData} />
      </div>
}
    </div>
  )
}

export default Users
